// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3GzIx","question":"Question_question__3K7dR","description":"Question_description__3msL1"};